import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateIndustryRequest extends BaseUpdateRequest {
    name = '';
}